import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
import { coinAnimFn } from "@utils/index";
import { mapState, mapActions } from "vuex";
import vailcode from "@utils/errcode";
export default {
  name: "popUsdInvite",
  computed: {
    ...mapState("wallet", ["setting"]),
    ...mapState("user", ["userData"])
  },
  watch: {
    "$parent.popUsdInviteShow": {
      async handler(bool) {
        if (bool) {
          this.$nextTick(this.eventListenerScroll);
        } else {}
      }
    }
  },
  data() {
    return {
      myReward: 0,
      activityListPage: {
        page: 1,
        limit: 15,
        isLoading: false,
        totalPages: 1
      },
      isPageLoading: false,
      activityList: [],
      isInviteLoading: false,
      isRefresh: false
    };
  },
  methods: {
    async onRefresh() {
      if (this.isRefresh) return;
      this.isRefresh = true;
      await this.getInviteRewardInfo();
      if (this.$parent?.$refs?.nCurrencyTwoRef) {
        this.$parent.$refs.nCurrencyTwoRef.getCurrencyData();
      }
      this.$nextTick(this.eventListenerScroll);
      await new Promise(resolve => setTimeout(resolve, 500));
      this.isRefresh = false;
    },
    getInviteMsgId() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/mpay/preinlinemessage", {});
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            this.isInviteLoading = false;
            resolve();
            return;
          }
          this.isInviteLoading = false;
          resolve(data.id);
        }, () => {
          resolve();
        });
      });
    },
    async onInvite() {
      if (this.isInviteLoading) return;
      this.isInviteLoading = true;
      console.log("this.WebApp", this.WebApp);
      // const msgId = await this.getInviteMsgId();
      // if (!msgId) {
      //   this.$toasted.error("Invite error!");
      //   this.isInviteLoading = false;
      //   return;
      // }
      // try {
      //   if (this.WebApp?.shareMessage) {
      //     this.WebApp.shareMessage(msgId, (success) => {
      //       this.isInviteLoading = false;
      //       if (success) {
      //         this.$toasted.success("Share success!");
      //       }
      //     });
      //   }
      // } catch (err) {
      // }
      const linkname = "1,000,000 USDT for free!\n";
      let url = `https://t.me/share/url?text=${encodeURIComponent(linkname)}&url=https://t.me/${this.setting.botname}/app?startapp=ref_${this.userData.ref_code}-page_${this.$route.name == "usdLucky" ? "usdEvent" : this.$route.name}`;
      this.isInviteLoading = false;
      this.WebApp.openTelegramLink(url);
    },
    async getInviteRewardInfo() {
      const res = await this.$http.post("/lucky/lottery/invitation/reward/info", {});
      vailcode(res, () => {
        if (!res.data) {
          return;
        }
        this.myReward = res.data.total_amount;
        console.log(" this.myReward", this.myReward);
      });
    },
    async getActivityList(page = 1, limit = 10) {
      this.activityListPage.isLoading = true;
      // // 模拟后端总数据
      // const allItems = Array.from({ length: 100 }, (_, i) => ({
      //   id: i + 1,

      //   avatar_url: null,
      //   created_at: new Date().toISOString(),
      //   from_user: {
      //     id: 33,
      //     firstname: "User adsfndsahfishdfowenrwenrvosdfusodfu",
      //     lastname: `#${i + 1}`,
      //     head_color: "#cf5fa7",
      //     avatar_url: null,
      //   },
      //   token: "TAP",
      //   chain: "ton",
      //   user_id: 33,
      //   amount: 30 + i,
      // }));

      // const total = allItems.length;
      // const start = (page - 1) * limit;
      // const end = page * limit;
      // const paginatedItems = allItems.slice(start, end);

      // const res = {
      //   code: 0,
      //   message: "",
      //   data: {
      //     total,
      //     perPage: limit,
      //     lastPage: Math.ceil(total / limit),
      //     currentPage: page,
      //     items: paginatedItems,
      //   },
      // };
      const res = await _v.$http.post("/lucky/lottery/invitation/reward/logs", {
        page,
        limit
      });
      return new Promise(resolve => {
        vailcode(res, () => {
          const items = res.data.items || [];
          if (page === 1) {
            this.activityList = items;
          } else {
            this.activityList.push(...items);
          }
          this.activityListPage.totalPages = res.data.lastPage;
          this.activityListPage.page = page;
          this.activityListPage.isLoading = false;
          resolve(items);
        }, () => {
          this.activityListPage.isLoading = false;
          resolve([]);
        });
      });
    },
    eventListenerScroll() {
      this.isPageLoading = true;
      this.$nextTick(async () => {
        await this.getActivityList(1, this.activityListPage.limit);
        this.isPageLoading = false;
        this.$nextTick(() => {
          const container = this.$refs.popUsdInviteRef;
          if (container) {
            container.addEventListener("scroll", this.handleScroll);
          }
        });
      });
    },
    async handleScroll(e) {
      const el = e.target;
      const {
        isLoading,
        page,
        totalPages,
        limit
      } = this.activityListPage;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10 && !isLoading && page < totalPages) {
        this.activityListPage.isLoading = true;
        try {
          await this.getActivityList(page + 1, limit);
        } finally {
          this.activityListPage.isLoading = false;
        }
      }
    }
  },
  async mounted() {
    await this.getInviteRewardInfo();
  }
};